//we can send props to this component : media, url, navigate, bigSize, title, bodyvalue, bodykey
import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate } from "react-router-dom";
import Spinner from "../loadingbar/Spinner";
import { Line } from "rc-progress";
import config from "../../config";

const DropZone = (props) => {
  const [filenames, setFilenames] = useState([]);
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isSimple, setIsSimple] = useState(0);
  const [isFormulaMcq, setIsFormulaMcq] = useState(0);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  // const query = new URLSearchParams(window.location.search);
  // let from = query.get("type");

  // Track upload progress
  const onProgress = (event) => {
    setLoading(true);
    if (event.lengthComputable) {
      const percentComplete = (event.loaded / event.total) * 100;
      setProgress(percentComplete);
    }
  };

  // Create / Post media with progress tracking
  const onSubmit = async () => {
    setLoading(true);
    setProgress(0); // Reset progress to 0 before starting the upload
    try {
      const formData = new FormData();
      formData.append("from", props.isExamOrMcq.from);
      acceptedFiles.forEach((file) => {
        formData.append(props.media ? "media" : "excel", file);
      });
      formData.append("isSimple", isSimple);
      formData.append("isFormula", isFormulaMcq);
      if (props.bodykey) {
        if (!props.bodyvalue || props.bodyvalue === undefined) {
          setLoading(false);
          triggerNotification("error", "Please select question bank.");
          return;
        }
        formData.append(props.bodykey, props.bodyvalue);
      }
      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener("progress", onProgress);
      xhr.open("POST", `${config.host_url}${props.url}?from=${props.isExamOrMcq.from}`);
      xhr.setRequestHeader("token", token);
      xhr.send(formData);

      xhr.onload = () => {
        // Handle the response as before
        if (xhr.status === 200) {
          // Clear the accepted files and filenames
          setAcceptedFiles([]);
          setFilenames([]);

          // Show success message
          triggerNotification("success", "File Upload Successfully");
          if (props.navigate) {
            
            if (props.type == "mcq") {
              // props.onDone();
              // console.log(from);
              // window.location.reload();
            } else {
              navigate("/" + props.navigate);
            }
          }
        } else if (xhr.status === 404) {
          // No Media Files Provided
          triggerNotification("error", "No Files Provided.");
        } else if (xhr.status === 401) {
          // Invalid Token
          triggerNotification(
            "error",
            "You do not have permission to upload a file!"
          );
        } else {
          // Internal Server Error or other HTTP errors
          triggerNotification(
            "error",
            "Internal server error, please try again later!"
          );
        }

        // Clear the progress after the upload is complete
        setProgress(0);
        setLoading(false);
      };
    } catch (error) {
      // Handle errors here and show an error message
      triggerNotification("error", "File not added, please try again later.");
    }
  };

  // Select files from local machine to dropzone
  const onDrop = useCallback(
    (files) => {
      // Update the acceptedFiles state with the accepted files
      setAcceptedFiles(files);

      // Update the filenames state with the names of the accepted files
      const newFilenames = files.map((file) => file.name);
      setFilenames(newFilenames);
    },
    [setAcceptedFiles, setFilenames]
  );

  // Dropzone package functionality
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <>
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header  align-items-center  ">
            <h5 className="mb-0">
              {props.title ? props.title : "Add Data from an Excel File"}
            </h5>
            {loading ? <Spinner /> : ""}
            <div {...getRootProps()} className="text-center p-8 ">
              <div
                className={`border-dashed border-1 border-gray-300 ${
                  props.bigSize ? "p-20" : "p-7"
                } rounded`}
              >
                <input {...getInputProps()} />
                {filenames.length > 0 ? (
                  <>
                    <ul>
                      {filenames.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                    {loading && (
                      <div className="mx-auto  w-96">
                        <Line
                          percent={progress}
                          strokeWidth="1"
                          strokeColor="#0078d4"
                          strokeLinecap="round"
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <p>
                      Drag and drop some files here, or click to select files
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className="flex">
            {props.type == "mcq" ? (
              <div className="flex items-center mb-2.5 ml-8">
                {isSimple == 1 ? (
                  <span
                    className="mdi mdi-checkbox-marked-outline mr-2 "
                    onClick={() => setIsSimple(0)}
                  ></span>
                ) : (
                  <span
                    className="mdi mdi-checkbox-blank-outline mr-2 "
                    onClick={() => setIsSimple(1)}
                  ></span>
                )}
                <label htmlFor="">Select Single Choice Mcq</label>
              </div>
            ) : (
              ""
            )}
            {props.type == "mcq" ? (
              <div className="flex items-center mb-2.5 ml-8">
                {isFormulaMcq == 1 ? (
                  <span
                    className="mdi mdi-checkbox-marked-outline mr-2 "
                    onClick={() => setIsFormulaMcq(0)}
                  ></span>
                ) : (
                  <span
                    className="mdi mdi-checkbox-blank-outline mr-2 "
                    onClick={() => setIsFormulaMcq(1)}
                  ></span>
                )}
                <label htmlFor="">Select Formula Mcq</label>
              </div>
            ) : (
              ""
            )}
            </div>
            <div
              className={`flex ${
                !(props.type === undefined || props.type === "")
                  ? "justify-between"
                  : "justify-end"
              } `}
            >
              {!(props.type === undefined || props.type === "") && (
                <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-8 mb-2">
                  <a
                    href={
                      props.type == "chap"
                        ? "https://deepvecto.com/api/deepVecto_chapter_data.zip"
                        : props.type == "mcq"
                        ? "https://deepvecto.com/api/deepVecto_mcq_data.zip"
                        : ""
                    }
                    className="text-white"
                  >
                    Download sample file
                  </a>
                </button>
              )}

              {filenames.length > 0 && (
                <button
                  onClick={onSubmit}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-8 mb-2"
                >
                  Upload
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DropZone;
